module.exports = __webpack_public_path__ + "img/mci_logo.df6c3719.ecd6d3fb.png";